export default {
  title: {
    'approve-success': 'การอนุมัติสำเร็จแล้ว',
    'reject-success': 'การยกเลิกสำเร็จแล้ว'
  },
  button: 'กลับสู่หน้าหลัก'
}
